export function isNotFoundRouteError(error: unknown): boolean {
  if (error == null || typeof error !== "object") {
    return false;
  }
  const status =
    "status" in error && typeof error.status === "number"
      ? error.status
      : undefined;
  const statusCode =
    "statusCode" in error && typeof error.statusCode === "number"
      ? error.statusCode
      : undefined;
  const statusText =
    "statusText" in error && typeof error.statusText === "string"
      ? error.statusText
      : undefined;
  return status === 404 || statusCode === 404 || statusText === "Not Found";
}
